import client from './client';

export async function list(params = {}) { const { data } = await client.get('/api/zones', { params }); return data; }
export async function get(id)           { const { data } = await client.get(`/api/zones/${id}`);  return data; }
export async function create(body)      { const { data } = await client.post('/api/zones', body); return data; }
export async function update(id, body)  { const { data } = await client.put(`/api/zones/${id}`, body); return data; }
export async function remove(id)        { const { data } = await client.delete(`/api/zones/${id}`); return data; }
export async function deactivate(id)    { const { data } = await client.patch(`/api/zones/${id}/deactivate`); return data; }
